import type { DadosProfissao } from "../types";

// Dados RAIS 2024 - Salários médios por profissão ajustados para 40h semanais

export const PROFISSOES_POR_ESTADO: Record<string, DadosProfissao> = {
  "DF": {
    medico: 22343,
    enfermeiro: 8854,
    professor: 5840
  },
  
  "SP": {
    medico: 24519,
    enfermeiro: 6878,
    professor: 5627
  },
  
  "RJ": {
    medico: 18161,
    enfermeiro: 5214,
    professor: 4794
  },
  
  "SC": {
    medico: 18652,
    enfermeiro: 5173,
    professor: 4294
  },
  
  "PR": {
    medico: 13781,
    enfermeiro: 4715,
    professor: 4035
  },
  
  "RS": {
    medico: 27877,
    enfermeiro: 7316,
    professor: 5909
  },
  
  "MT": {
    medico: 13779,
    enfermeiro: 4528,
    professor: 5410
  },
  
  "MS": {
    medico: 18952,
    enfermeiro: 4723,
    professor: 3877
  },
  
  "GO": {
    medico: 13511,
    enfermeiro: 4807,
    professor: 4151
  },
  
  "ES": {
    medico: 17382,
    enfermeiro: 4806,
    professor: 4965
  },
  
  "MG": {
    medico: 17793,
    enfermeiro: 5041,
    professor: 5424
  },
  
  "RO": {
    medico: 11520,
    enfermeiro: 4481,
    professor: 3350
  },
  
  "RR": {
    medico: 18298,
    enfermeiro: 3478,
    professor: 3754
  },
  
  "TO": {
    medico: 12907,
    enfermeiro: 4704,
    professor: 3914
  },
  
  "AP": {
    medico: 12866,
    enfermeiro: 5055,
    professor: 2532
  },
  
  "RN": {
    medico: 10290,
    enfermeiro: 5211,
    professor: 2541
  },
  
  "PE": {
    medico: 14059,
    enfermeiro: 5219,
    professor: 3436
  },
  
  "AC": {
    medico: 14628,
    enfermeiro: 4851,
    professor: 3882
  },
  
  "PA": {
    medico: 14035,
    enfermeiro: 4687,
    professor: 3529
  },
  
  "AL": {
    medico: 12866,
    enfermeiro: 4414,
    professor: 2963
  },
  
  "SE": {
    medico: 11051,
    enfermeiro: 4584,
    professor: 2784
  },
  
  "AM": {
    medico: 13482,
    enfermeiro: 4707,
    professor: 3174
  },
  
  "PI": {
    medico: 11623,
    enfermeiro: 4462,
    professor: 3492
  },
  
  "PB": {
    medico: 11911,
    enfermeiro: 4027,
    professor: 3067
  },
  
  "CE": {
    medico: 21430,
    enfermeiro: 5452,
    professor: 2687
  },
  
  "BA": {
    medico: 14720,
    enfermeiro: 5044,
    professor: 3689
  },
  
  "MA": {
    medico: 17443,
    enfermeiro: 4606,
    professor: 2925
  }
} as const;

export const obterProfissoesEstado = (estado: string): DadosProfissao => {
  return PROFISSOES_POR_ESTADO[estado as keyof typeof PROFISSOES_POR_ESTADO];
};